import React, { useCallback, useState } from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import Price from '@/price/Price'
import CreditsModal from '@user/customer/modals/Account/Credits/CreditsModal'
import { useCustomer } from 'hooks/useSession'
import cn from '@ui/utils/cn'

export default function CreditsSection({
  disabled = false,
}: {
  disabled?: boolean
}) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['customer'])
  const text = 'customer:home.sections.credits'
  const [open, setOpen] = useState(false)

  const customer = useCustomer()
  const credits = customer?.credit || 0

  const handleOpen = useCallback(() => setOpen(true), [])

  const handleClose = useCallback(() => setOpen(false), [])

  if (disabled) {
    return null
  }

  return (
    <>
      <Pressable
        onPress={handleOpen}
        disabled={disabled}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className={cn('flex-1', disabled && 'opacity-25')}
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={handleOpen}
              size="sm"
              variant="outlined"
              label={
                <Price
                  showZero
                  value={credits}
                  noPrecision={credits > 0 && credits >= 100}
                />
              }
            />
          }
          glassProps={{
            animation,
            image: require('@/images/credits.png'),
            imageWrapperStyle: {
              width: '110%',
              height: '110%',
              transformOrigin: 'bottom right',
            },
            imageStyle: {
              transform: Platform.select({
                default: [{ translateX: 185 }, { translateY: 25 }],
                web: [{ translateX: 210 }, { translateY: 25 }],
              }),
            },
            blur: Platform.select({ default: 100, web: 50 }),
            blurStyle: {
              opacity: 1,
              transform: [
                { translateX: 100 },
                { translateY: 75 },
                { scale: 1.2 },
              ],
            },
          }}
        />
      </Pressable>
      <CreditsModal open={open} close={handleClose} />
    </>
  )
}
